import { render, staticRenderFns } from "./LoggedInAsOtherUserWarning.vue?vue&type=template&id=0e7478b7&scoped=true&"
import script from "./LoggedInAsOtherUserWarning.vue?vue&type=script&lang=js&"
export * from "./LoggedInAsOtherUserWarning.vue?vue&type=script&lang=js&"
import style0 from "./LoggedInAsOtherUserWarning.vue?vue&type=style&index=0&id=0e7478b7&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7478b7",
  null
  
)

/* custom blocks */
import block0 from "./LoggedInAsOtherUserWarning.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7478b7')) {
      api.createRecord('0e7478b7', component.options)
    } else {
      api.reload('0e7478b7', component.options)
    }
    module.hot.accept("./LoggedInAsOtherUserWarning.vue?vue&type=template&id=0e7478b7&scoped=true&", function () {
      api.rerender('0e7478b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/LoggedInAsOtherUserWarning.vue"
export default component.exports